import React, { useEffect, useState } from 'react';
import { Dropdown } from 'common/components';
import { useClassName } from 'common/hooks';
import './sticky-dropdown.less';

const OFFSET = 150;

const StickyDropdown = ({
  options,
  selectedIndex,
  parentRef,
  handleChange,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0 }
    );

    if (parentRef.current) observer.observe(parentRef.current);
    return () => observer.disconnect();
  }, []);

  const classNames = useClassName('StickyDropdown');

  const handleOptionSelected = (option) => {
    const y =
      parentRef.current.getBoundingClientRect().top + window.scrollY - OFFSET;
    window.scrollTo({ top: y, behavior: 'smooth' });
    handleChange(option);
  };

  return (
    <Dropdown
      options={options.map((category) => ({
        label: category,
        value: category,
      }))}
      selected={options[selectedIndex]}
      handleChange={handleOptionSelected}
      classNames={classNames(
        'options-dropdown',
        isVisible ? 'visible' : 'hidden'
      )}
    />
  );
};

export default StickyDropdown;
